export default function checkResource(url, ChartWrap) {
  fetch(url, { method: 'HEAD', mode: 'no-cors' })
    .then((response) => {
      if (response.ok) {
        console.warn(`Ресурс доступен: ${url}`);
      } else {
        console.warn(`Ресурс заблокирован или недоступен: ${url}`);
        // const ChartWrap = document.querySelectorAll(`.js-stock-chart-wrap`);
        if (ChartWrap) {
          ChartWrap.forEach((cw) => {
            cw.classList.add('charts__block-error-loading');
            cw.innerHTML = `<img src="/assets/images/error-data.gif">Ошибка загрузки<br>Пожалуйста, обновите страницу`;
          });
        }
      }
    })
    .catch((error) => {
      console.warn(`Ошибка при проверке ресурса: ${error.message}`);
      // const ChartWrap = document.querySelectorAll(`.js-stock-chart-wrap`);
      if (ChartWrap) {
        ChartWrap.forEach((cw) => {
          cw.classList.add('charts__block-error-loading');
          cw.innerHTML = `<img src="/assets/images/error-data.gif">Ошибка загрузки<br>Пожалуйста, обновите страницу`;
        });
      }
    });

}